// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-breakpoint {
  pointer-events: none;
}

.bolt-breakpoint-container {
  height: 2px;
}

.bolt-breakpoint-observation {
  bottom: 0;
  left: 0;
  top: 0;
}

/*# sourceMappingURL=Breakpoint.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Breakpoint/Breakpoint.scss","webpack://./../azure-devops-ui/bin/Components/Breakpoint/Breakpoint.css"],"names":[],"mappings":"AAAA;EACI,oBAAA;ACCJ;;ADEA;EACI,WAAA;ACCJ;;ADEA;EACI,SAAA;EACA,OAAA;EACA,MAAA;ACCJ;;AAEA,yCAAyC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
